/**
 * Время в мс, через которое будет удаляться toast
 * @type {number}
 */

const config = {
  position: 'top right',
  duration: 5000
}

export default {
  /**
   *
   * @param Vue
   * @param options
   */
  install(Vue, options) {
    /**
     *
     * @param text
     * @param group
     */
    Vue.prototype.$success = function (text, group = '') {
      this.$notify({
        group,
        type: 'success',
        title: 'Успешно',
        text,
        ...config
      })
    }
    /**
     *
     * @param text
     * @param title
     * @param group
     */
    Vue.prototype.$warning = function (text, title = 'Предупреждение', group = '') {
      this.$notify({
        group,
        type: 'warn',
        title,
        text,
        ...config
      })
    }

    Vue.prototype.$warningTitle = function (title, text, group = '') {
      this.$notify({
        group,
        type: 'warn',
        title,
        text,
        ...config
      })
    }
    /**
     *
     * @param text
     * @param group
     */
    Vue.prototype.$danger = function (text, group = '') {
      this.$notify({
        group,
        type: 'error',
        title: 'Ошибка',
        text,
        ...config
      })
    }
    /**
     *
     * @param title
     * @param text
     * @param group
     */
    Vue.prototype.$message = function (title, text, group = '') {
      this.$notify({
        type: 'primary',
        group,
        title,
        text,
        ...config,
      })
    }
  }
}
